import { SOURCE_MULTI_SKU_NUM, UserGetMode } from '@/components/MultiSkuModalGolden/constant';
import { MultiSkuModel } from '@/shop/shop_multi_sku_modal/component';
import Constant from '@/utils/constant';
import {
  GoodDetailData, GoodDetailSkuList, SelectedSkuList, NutritionAllergenType
} from '../../../pages/shop/c_shop_golden/component';
import { TotalPrice } from '../Store/model';

const Statistics = Mach.requireModule('Statistics');

export const EVENT_TYPE = {
  MV: 0,
  MC: 1
};
const eventTypes = ['mv', 'mc'];
export const ILLEGAL_VALUE = -999;

const formatBIDBasedType = (bidPrefix, type) => `${bidPrefix}_${eventTypes[type]}`;

function sendLXBeacon(bidPrefix, type, lab) {
  const bid = formatBIDBasedType(bidPrefix, type);

  switch (type) {
    case 0: {
      // eslint-disable-next-line
      Statistics.view(TrackUtils.cid, bid, lab);
      break;
    }
    case 1: {
      // eslint-disable-next-line
      Statistics.click(TrackUtils.cid, bid, lab);
      break;
    }
  }
}

export const CID = {
  /** 门店source 0：商品列表 2：购物车浮层 5: 首页feed流下挂菜卡片跳转*/
  shop: 'c_waimai_c_overseas_t0hfbtfg',
  /** 一人食source：1 */
  fixed_price: 'c_waimai_c_overseas_sn7wr5pd',
  /** 919促销落地页source：3 */
  nine_one_nine: 'c_sailor_c_887tosbv',
  /** 高达促销落地页 source: >=4 */
  multi_sku_modal: 'c_sailor_c_zamjat4k'
};

export const CID_SOURCE = {
  0: CID.shop,
  2: CID.shop,
  1: CID.fixed_price,
  3: CID.nine_one_nine,
  4: CID.multi_sku_modal,
  5: CID.multi_sku_modal,
};

// BID合并
export const BID = {
  // 点菜页多规格浮层-曝光
  POI_CHOOSE_SPEC_VIEW_BID: {
    MV: 'b_waimai_c_overseas_zcj8vpow_mv',
  },
  //一口价多规格浮层-曝光
  FIXED_PRICE_POI_CHOOSE_SPEC: {
    MV: 'b_waimai_c_overseas_wq2wxft1_mv',
  },
  // 高达多规格浮层-曝光
  GUNDAM_MULTI_SKU_MODAL_BID: {
    MV: 'b_sailor_c_xakjane4_mv'
  },
  // 一人食-进店入口
  FIXED_PRICE_SHOP_ENTRY: {
    MV: 'b_sailor_c_kobphk12_mv',
    MC: 'b_sailor_c_kobphk12_mc'
  },
  //商品规格浮层-主规格模块曝光
  MULT_SKU_VARIATION: {
    MV: 'b_sailor_c_508pahrw_mv',
  },

  //一口价-商品规格浮层-主规格模块曝光
  FIXED_PRICE_MULT_SKU_VARIATION: {
    MV: 'b_sailor_c_ttcmoimk_mv',
  },
  // 高达-商品规格浮层-主规格模块曝光
  GUNDAM_MULT_SKU_VARIATION: {
    MV: 'b_sailor_c_cvngfvx9_mv',
  },

  // 商品规格浮层-加入购物车 点击
  MULT_SKU_ADD_TO_SHOPCART_BTN: {
    MC: 'b_waimai_c_overseas_0jfd5vmd_mc',
  },
  // 一口价-商品规格浮层-加入购物车 点击
  FIXED_PRICE_MULT_SKU_ADD_TO_SHOPCART_BTN: {
    MC: 'b_waimai_c_overseas_ocjy513m_mc',
  },
  //商品规格浮层-数量修改-点击
  MULT_SKU_CHANGE_COUNT: {
    MC: 'b_waimai_c_overseas_eag2ivu5_mc',
  },
  //商品规格浮层-备注
  MULT_SKU_REMARK: {
    MV: 'b_waimai_c_overseas_wbguyjeh_mv',
    MC: 'b_waimai_c_overseas_wbguyjeh_mc',
  },
  //高达商品规格浮层-备注
  GUNDAM_MULT_SKU_REMARK: {
    MV: 'b_sailor_c_5ex3ersp_mv',
    MC: 'b_sailor_c_5ex3ersp_mc',
  },

  //一口价-商品规格浮层-备注
  FIXED_PRICE_MULT_SKU_REMARK: {
    MV: 'b_waimai_c_overseas_vx15y657_mv',
    MC: 'b_waimai_c_overseas_vx15y657_mc',
  },

  // 商品规格浮层-规格选择模块-曝光
  MULT_SKU_SKULIST: {
    MV: 'b_waimai_c_overseas_3w7w6xsq_mv',
  },
  // 高达商品规格浮层-规格选择模块-曝光
  GUNDAM_MULT_SKU_SKULIST: {
    MV: 'b_sailor_c_j3fzv4e4_mv',
  },
  // 一口价-商品规格浮层-规格选择模块-曝光
  FIXED_PRICE_MULT_SKU_SKULIST: {
    MV: 'b_waimai_c_overseas_f2cwprtp_mv',
  },

  // 商品规格浮层-分享-点击
  MULT_SKU_SHARE_BTN: {
    MC: 'b_waimai_c_overseas_gi1hj3vz_mc',
  },
  //一口价-商品规格浮层-分享-点击
  FIXED_PRICE_MULT_SKU_SHARE_BTN: {
    MC: 'b_waimai_c_overseas_i19gqd57_mc',
  },
  // 919活动多规格浮层-曝光
  NINE_ONE_NINE_MULT_SKU_BID: {
    MV: 'b_sailor_c_b46bt25n_mv',
  },
  MARKETFLOADINGLAYER_BID: {
    MV: 'b_sailor_c_7uqyeozr_mv',
    MC: 'b_sailor_c_eu60n8ky_mc'
  },
  MARKETFLOADINGLAYER_POPUP_VIEW_BID: {
    MV: 'b_sailor_c_5rbyzw11_mv',
    MC: 'b_sailor_c_5rbyzw11_mc',
  },
  NINE_ONE_NINE_POPUP_VIEW_BID: {
    MV: 'b_sailor_c_25g2hopm_mv',
    MC: 'b_sailor_c_25g2hopm_mc',
  },
  // 919活动落地页-规格浮层-加购 点击
  NINE_ONE_NINE_MULT_SKU_ADD_TO_SHOPCART_BTN: {
    MC: 'b_sailor_c_tlc84rn1_mc',
  },
  // 通用弹窗曝光
  PREVIEW_COMMON_DIALOG_BID: {
    MV: 'b_sailor_c_lrycrk7b_mv',
    MC: 'b_sailor_c_lrycrk7b_mc'
  },
  // 一人食弹窗埋点
  FIXED_PRICE_COMMON_DIALOG_BID: {
    MV: 'b_sailor_c_xjvibwep_mv',
    MC: 'b_sailor_c_xjvibwep_mc'
  },

  // 提示横条-进入门店
  NORMAL_MULTI_SKU_MODAL_ENTER_SHOP_BID: {
    MV: 'b_sailor_c_fbjupd3f_mv',
    MC: 'b_sailor_c_fbjupd3f_mc'
  },

  // 去结算
  NORMAL_MULTI_SKU_MODAL_CHECKOUT_BID: {
    MC: 'b_sailor_c_eapan4ot_mc'
  },

  // 商品规格浮层-规格选择模块-多选-曝光
  NORMAL_MULTI_SKU_MODAL_STEPPER_BID: {
    MC: 'b_waimai_c_overseas_eag2ivu5_mc'
  },

  MULTI_SAME_SPU_LANDSCAPE_VIEW_BID: {
    MC: 'b_sailor_c_0k5s2xep_mc',
    MV: 'b_sailor_c_0k5s2xep_mv'
  },

  // 营养成分/过敏源 点击&曝光
  NUTRITION_ALLERGEN_BID: {
    MC: 'b_sailor_c_i5yj4g5w_mc',
    MV: 'b_sailor_c_i5yj4g5w_mv',
  }
};

const BID_SOURCE = {
  // 点菜页多规格浮层-曝光
  POI_CHOOSE_SPEC: {
    MV: {
      0: BID.POI_CHOOSE_SPEC_VIEW_BID.MV,
      1: BID.FIXED_PRICE_POI_CHOOSE_SPEC.MV,
      2: BID.POI_CHOOSE_SPEC_VIEW_BID.MV,
      3: BID.NINE_ONE_NINE_MULT_SKU_BID.MV,
      4: BID.GUNDAM_MULTI_SKU_MODAL_BID.MV,
      5: BID.GUNDAM_MULTI_SKU_MODAL_BID.MV,
    }
  },
  // 一人食-进店入口
  FIXED_PRICE_SHOP_ENTRY: {
    MV: {
      1: BID.FIXED_PRICE_SHOP_ENTRY.MV,
    },
    MC: {
      1: BID.FIXED_PRICE_SHOP_ENTRY.MC,
    }
  },
  //商品规格浮层-主规格模块曝光
  MULT_SKU_VARIATION: {
    MV: {
      0: BID.MULT_SKU_VARIATION.MV,
      2: BID.MULT_SKU_VARIATION.MV,
      1: BID.FIXED_PRICE_MULT_SKU_VARIATION.MV,
      4: BID.GUNDAM_MULT_SKU_VARIATION.MV,
      5: BID.GUNDAM_MULT_SKU_VARIATION.MV,
    }
  },
  //商品规格浮层-备注
  MULT_SKU_REMARK: {
    MV: {
      0: BID.MULT_SKU_REMARK.MV,
      2: BID.MULT_SKU_REMARK.MV,
      1: BID.FIXED_PRICE_MULT_SKU_REMARK.MV,
      4: BID.GUNDAM_MULT_SKU_REMARK.MV,
      5: BID.GUNDAM_MULT_SKU_REMARK.MV,
    },
    MC: {
      0: BID.MULT_SKU_REMARK.MC,
      2: BID.MULT_SKU_REMARK.MC,
      1: BID.FIXED_PRICE_MULT_SKU_REMARK.MC,
      4: BID.GUNDAM_MULT_SKU_REMARK.MC,
      5: BID.GUNDAM_MULT_SKU_REMARK.MC,
    },
  },
  // 商品规格浮层-规格选择模块-曝光
  MULT_SKU_SKULIST: {
    MV: {
      0: BID.MULT_SKU_SKULIST.MV,
      2: BID.MULT_SKU_SKULIST.MV,
      1: BID.FIXED_PRICE_MULT_SKU_SKULIST.MV,
      4: BID.GUNDAM_MULT_SKU_SKULIST.MV,
      5: BID.GUNDAM_MULT_SKU_SKULIST.MV,
    }
  },
  //商品规格浮层-分享-点击
  MULT_SKU_SHARE_BTN: {
    MC: {
      0: BID.MULT_SKU_SHARE_BTN.MC,
      2: BID.MULT_SKU_SHARE_BTN.MC,
      1: BID.FIXED_PRICE_MULT_SKU_SHARE_BTN.MC,
    }
  },
  // 通用弹窗曝光
  PREVIEW_COMMON_DIALOG_BID: {
    MV: {
      0: BID.PREVIEW_COMMON_DIALOG_BID.MV,
      2: BID.PREVIEW_COMMON_DIALOG_BID.MV,
      4: BID.PREVIEW_COMMON_DIALOG_BID.MV,
      5: BID.PREVIEW_COMMON_DIALOG_BID.MV,
      1: BID.FIXED_PRICE_COMMON_DIALOG_BID.MV,
    },
    MC: {
      0: BID.PREVIEW_COMMON_DIALOG_BID.MC,
      2: BID.PREVIEW_COMMON_DIALOG_BID.MC,
      4: BID.PREVIEW_COMMON_DIALOG_BID.MC,
      5: BID.PREVIEW_COMMON_DIALOG_BID.MC,
      1: BID.FIXED_PRICE_COMMON_DIALOG_BID.MC,
    }
  },
  // 提示横条-进入门店
  NORMAL_MULTI_SKU_MODAL_ENTER_SHOP_BID: {
    MV: {
      4: BID.NORMAL_MULTI_SKU_MODAL_ENTER_SHOP_BID.MV,
      5: BID.NORMAL_MULTI_SKU_MODAL_ENTER_SHOP_BID.MV
    },
    MC: {
      4: BID.NORMAL_MULTI_SKU_MODAL_ENTER_SHOP_BID.MC,
      5: BID.NORMAL_MULTI_SKU_MODAL_ENTER_SHOP_BID.MC
    }
  },
  // 去结算
  NORMAL_MULTI_SKU_MODAL_CHECKOUT_BID: {
    MC: {
      1: BID.NORMAL_MULTI_SKU_MODAL_CHECKOUT_BID.MC,
      3: BID.NORMAL_MULTI_SKU_MODAL_CHECKOUT_BID.MC,
      4: BID.NORMAL_MULTI_SKU_MODAL_CHECKOUT_BID.MC,
      5: BID.NORMAL_MULTI_SKU_MODAL_CHECKOUT_BID.MC,
    }
  },
  // 商品规格浮层-加入购物车 点击
  MULT_SKU_ADD_TO_SHOPCART_BTN: {
    MC: {
      0: BID.MULT_SKU_ADD_TO_SHOPCART_BTN.MC,
      2: BID.MULT_SKU_ADD_TO_SHOPCART_BTN.MC,
      5: BID.MULT_SKU_ADD_TO_SHOPCART_BTN.MC,
      1: BID.FIXED_PRICE_MULT_SKU_ADD_TO_SHOPCART_BTN.MC,
    }
  }
};

let userGetMode = UserGetMode.delivery;

export function setTrackUserGetMode(inputUserGetMode) {
  userGetMode = inputUserGetMode;
}
export function getTrackUserGetMode() {
  return userGetMode;
}

const getCID = (source) => CID_SOURCE?.[source] || CID_SOURCE[0];

const getBID = (source, bidKey, envntKey) => BID_SOURCE[bidKey]?.[envntKey]?.[source] || BID_SOURCE[bidKey]?.[envntKey]?.[0] || '';
export default class TrackUtils {
  static cid = CID.shop;

  /** source */
  static getMultiSkuModalLab = (multiSkuModel: MultiSkuModel, curGoodDetail: GoodDetailData, shopId: string, canUserCoupon: number | undefined, source: number) => {
    const user_get_mode = getTrackUserGetMode();
    const lab = {
      componentInfo: multiSkuModel?.componentInfo || {},
      customer_type: canUserCoupon || 0,
      gd_page_id: multiSkuModel?.gdPageId || '-999',
      gd_activity_id: multiSkuModel?.activity_id || '-999',
      resource_id: multiSkuModel?.resource_id || '-999',
      sku_index: multiSkuModel?.index || 0,
      sku_number: curGoodDetail?.skuList?.length || 0,
      shop_id: shopId,
      spu_id: curGoodDetail?.spuId,
      source_page: source,
      page_source: source,
      user_get_mode,
      original_price: curGoodDetail?.minPrice ?? {},
      sale_price: curGoodDetail?.discountPrice ?? {},
      picture_url: curGoodDetail?.pictures,
    };
    return lab;
  }

  //machpro弹窗类型多规格页面曝光埋点
  static multiSkuModalPageMV = (multiSkuModel: MultiSkuModel, curGoodDetail: GoodDetailData, shopId: string, canUserCoupon: number | undefined, source: number) => {
    const cid = getCID(source);
    const bid = getBID(source, 'POI_CHOOSE_SPEC', 'MV');
    const lab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);
    Statistics.view(cid, bid, lab);
  }

  static multiSkuModalEnterShopMV = (multiSkuModel: MultiSkuModel, curGoodDetail: GoodDetailData, shopId: string, canUserCoupon: number | undefined, source: number, originalPrice: string, discountPrice: string) => {
    const cid = getCID(source);
    const bid = getBID(source, 'NORMAL_MULTI_SKU_MODAL_ENTER_SHOP_BID', 'MV');
    const normalLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);
    const lab = {
      original_price: originalPrice || '0',
      sale_price: discountPrice || '0',
      ...normalLab
    };
    Statistics.view(cid, bid, lab);
  }

  static multiSkuModalEnterShopMC = (multiSkuModel: MultiSkuModel, curGoodDetail: GoodDetailData, shopId: string, canUserCoupon: number | undefined, source: number, originalPrice: string, discountPrice: string) => {
    const cid = getCID(source);
    const bid = getBID(source, 'NORMAL_MULTI_SKU_MODAL_ENTER_SHOP_BID', 'MC');
    const normalLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);
    const lab = {
      original_price: originalPrice || '0',
      sale_price: discountPrice || '0',
      ...normalLab
    };
    Statistics.click(cid, bid, lab);
  }

  static multiSkuModalCheckoutMC = (multiSkuModel: MultiSkuModel, curGoodDetail: GoodDetailData, shopId: string, selectedSkuId: number, canUserCoupon: number | undefined, source: number, originalPrice: string, discountPrice: string) => {
    const cid = getCID(source);
    const bid = getBID(source, 'NORMAL_MULTI_SKU_MODAL_CHECKOUT_BID', 'MC');
    const normalLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);
    const lab = {
      original_price: originalPrice || '0',
      sale_price: discountPrice || '0',
      sku_id: selectedSkuId || 0,
      ...normalLab
    };
    Statistics.click(cid, bid, lab);
  }

  // 营养成分/过敏源
  static reportNutritionAllergen = (type, params: NutritionAllergenType) => {
    const {
      shop_id, sku_id, spu_id, spu_property_type
    } = params;

    sendLXBeacon('b_sailor_c_i5yj4g5w', type, {
      shop_id, sku_id, spu_id, spu_property_type
    });
  }

  // 规格浮层-分享
  static reportShareBtn = (type, lab: any) => {
    sendLXBeacon('b_waimai_c_overseas_gi1hj3vz', type, {
      ...lab,
      user_get_mode: getTrackUserGetMode()
    });
  }

  // 提示横条-进入门店
  static reportMultiSkuModalEnterShop = (type, multiSkuModel: MultiSkuModel, curGoodDetail: GoodDetailData, shopId: string, canUserCoupon: number | undefined, source: number, originalPrice: string, discountPrice: string) => {
    const normalLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);
    const lab = {
      original_price: originalPrice || '0',
      sale_price: discountPrice || '0',
      ...normalLab
    };

    sendLXBeacon('b_sailor_c_fbjupd3f', type, lab);
  }

  // 商品规格浮层-数量修改
  static reportStepper = (type, lab) => {
    const user_get_mode = getTrackUserGetMode();

    sendLXBeacon('b_waimai_c_overseas_eag2ivu5', type, { ...lab, user_get_mode });
  }

  // 商品规格浮层-子规格点击-MC(用户点击某个多规格页的选项时上报, 选中态：1-选中，0-取消选中 )
  static reportSkuSelectMC = (source, lab) => {
    const cid = getCID(source);
    const bid = 'b_waimai_c_overseas_3w7w6xsq_mc';
    Statistics.click(cid, bid, lab);
  }

  // 一口价-规格浮层-门店入口
  static reportFixedPriceShopEntry = (type, source, shop_id: number) => {
    sendLXBeacon('b_sailor_c_kobphk12', type, { shop_id });
  }

  // 同店一人食套餐
  static reportMultiSameSpuChange = (type, source, lab) => {
    sendLXBeacon('b_sailor_c_0k5s2xep', type, lab);
  }

  // 店铺休息弹窗
  static reportPreviewCommonDialog = (type, source: number, shop_id: number, user_status: number, shop_brand_id: number, remind_reason: number) => {
    const lab = {
      shop_id,
      remind_reason,
      user_status,
      shop_brand_id
    };

    sendLXBeacon('b_sailor_c_lrycrk7b', type, lab);
  }

  // 规格浮层-加入购物车
  static reportAddShopcart = (
    type,
    key: string,
    source: number,
    totalPrice: TotalPrice,
    shop_id: string,
    sku: SelectedSkuList,
    count: number,
    curGoodDetail: GoodDetailData,
    {
      multiSkuModel,
      couponTips
    },
    tab_id: number,
    tab_index: number,
    successAddCart: number,
  ) => {
    const newGroupSkuList: string[] = [];
    if (sku.groupList && sku.groupList.length > 0) {
      sku.groupList.forEach((groupList) => {
        if (groupList.groupSkuList) {
          groupList.groupSkuList.forEach((groupSkuListItem) => {
            if (groupSkuListItem.count > 0) {
              newGroupSkuList.push(`${groupSkuListItem.groupSkuId},${groupSkuListItem.count}`);
            }
          });
        }
      });
    }
    const cid = TrackUtils.cid;
    const eventPrefix = 'b_waimai_c_overseas_0jfd5vmd';
    const bid = formatBIDBasedType(eventPrefix, type);
    const spu_specifications = newGroupSkuList.join(';');
    const user_get_mode = getTrackUserGetMode();
    const skuLab = {
      discount_information: sku.extraInfo?.logData ? (JSON.parse(sku.extraInfo.logData)?.discount_information ?? '') : '',
      // eslint-disable-next-line
      discount_amount: ((totalPrice.originPrice?.amount - totalPrice.discountPrice?.amount) / 100)?.toFixed(2),
      bid,
      original_price: totalPrice.originPrice,
      sale_price: totalPrice.discountPrice,
      shop_id,
      sku_id: sku.skuId,
      sku_number: count,
      spu_id: curGoodDetail?.spuId,
      currency_type: totalPrice.currency,
      discount_price: totalPrice?.discountPrice || '',
      activity_type: sku?.activityInfoList?.[0].activityType || 0,
      spu_specifications,
      user_get_mode,
      gd_page_id: multiSkuModel?.gdPageId || '-999',
      gd_activity_id: multiSkuModel?.activity_id || '-999',
      componentInfo: multiSkuModel?.componentInfo || {},
      customer_type: couponTips?.canUserCoupon || 0,
      tab_id: tab_id || Constant.STATISTICS_NON_VALUE, // 上报当前商品所在的菜单ID 如果是橱窗商品或搜索列表，则上报-999
      tab_index: tab_index ?? Constant.STATISTICS_NON_VALUE,
      source,
      success_add_cart: successAddCart
    };
    const tagLab = {
      [cid]: {
        ...skuLab,
        bid,
      },
    };
    Statistics.setTag && Statistics.setTag(key, tagLab);

    sendLXBeacon(eventPrefix, type, skuLab);
  }

  // 商品规格浮层-主规格点击-MC (用户点击某个多规格页的主选项时上报)
  static reportMainSkuMC = (source, lab) => {
    const cid = getCID(source);
    const bid = 'b_sailor_c_nkdex2jj_mc';
    Statistics.click(cid, bid, lab);
  }

  // 商品规格浮层-主规格曝光-MV
  static reportMainSkuMV = (source, lab) => {
    const cid = getCID(source);
    const bid = 'b_sailor_c_nkdex2jj_mv';
    Statistics.view(cid, bid, lab);
  }

  // 商品规格浮层-规格选择模块
  static reportAttrGroup = (type, source: number, shop_id: string, spu_id: number, spu_specifications_number: number, group_name: string, rule_tag: string, discount_price: string, activity_type: number, multiSkuModel, curGoodDetail, canUserCoupon) => {
    const normalLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shop_id, canUserCoupon, source);
    const user_get_mode = getTrackUserGetMode();

    const lab = {
      spu_specifications_number,
      group_name,
      rule_tag,
      discount_price,
      activity_type,
      user_get_mode,
      ...normalLab
    };

    sendLXBeacon('b_waimai_c_overseas_3w7w6xsq', type, lab);
  }

  // 商品规格浮层-备注
  static reportRemark = (type, source: number, shop_id: string, spu_id: number, multiSkuModel, curGoodDetail, shopId, canUserCoupon) => {
    const normalLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);

    sendLXBeacon('b_waimai_c_overseas_wbguyjeh', type, normalLab);
  }

  // 商品规格浮层-优惠选择
  static reportVariation = (type, lxparams) => {
    const {
      source,
      logData,
      spuCalorie,
      multiSkuModel,
      curGoodDetail,
      shopId,
      canUserCoupon,
      totalPrice,
      sku
    } = lxparams;
    const logDataForLx = logData ? JSON.parse(logData) : {};
    const spuCalorieForLx = { spu_calorie: spuCalorie || '' };
    const lab = { ...logDataForLx, ...spuCalorieForLx };
    const normalLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);

    sendLXBeacon('b_sailor_c_ttcmoimk', type, {
      // eslint-disable-next-line
      discount_amount: ((totalPrice.originPrice?.amount - totalPrice.discountPrice?.amount) / 100)?.toFixed(2),
      sku_id: sku.skuId,
      discount_information: sku.extraInfo?.logData ? (JSON.parse(sku.extraInfo.logData)?.discount_information ?? '') : '',
      ...lab,
      ...normalLab,
    });
  }

  // 点菜页多规格浮层-曝光
  static reportMultiSkuPage(type, lxParams) {
    const {
      multiSkuModel,
      source,
      shopId,
      curGoodDetail,
      selectedSku,
      moduleSource,
      canUserCoupon
    } = lxParams;
    // 是否为自动打开多规格浮层moduleSource
    const commonLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);
    const lab = {
      ...commonLab,
      module_source: moduleSource,
      sku_id: selectedSku?.skuId
    };

    sendLXBeacon('b_waimai_c_overseas_zcj8vpow', type, lab);
  }

  // 多规格页面曝光埋点
  static multiSkuPageMV = (source: number, shopId: string, curGoodDetail: GoodDetailData, selectedSku: GoodDetailSkuList, moduleSource?: string) => {
    const cid = getCID(source);
    const bid = getBID(source, 'POI_CHOOSE_SPEC', 'MV');
    const user_get_mode = getTrackUserGetMode();
    // 是否为自动打开多规格浮层moduleSource
    const lab = {
      picture_url: curGoodDetail.pictures,
      shop_id: shopId,
      spu_description: curGoodDetail.description,
      spu_id: curGoodDetail.spuId,
      sku_id: selectedSku?.skuId,
      source_page: source,
      user_get_mode,
      /** module_source: 1 金刚落地页下挂菜卡片跳转(金刚落地页细分场景） */
      module_source: moduleSource || Constant.STATISTICS_NON_VALUE,
    };
    Statistics.view(cid, bid, lab);
  }

  static variationMV = (source: number, logData: string | undefined, spuCalorie: string | undefined, multiSkuModel, curGoodDetail, shopId, canUserCoupon) => {
    const cid = getCID(source);
    const bid = getBID(source, 'MULT_SKU_VARIATION', 'MV');
    const logDataForLx = logData ? JSON.parse(logData) : {};
    const spuCalorieForLx = { spu_calorie: spuCalorie || '' };
    const lab = { ...logDataForLx, ...spuCalorieForLx };
    const user_get_mode = getTrackUserGetMode();
    const normalLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);

    Statistics.view(cid, bid, {
      ...lab,
      user_get_mode,
      ...normalLab
    });
  }

  // 规格浮层-分享点击
  static shareBtnMC = (lab: any) => {
    const cid = getCID(lab.source_page);
    const bid = getBID(lab.source_page, 'MULT_SKU_SHARE_BTN', 'MC');
    Statistics.click(cid, bid, lab);
  }

  // 规格浮层-加入购物车
  static addShopcartMC = (key: string, source: number, totalPrice: TotalPrice, shop_id: string, sku: SelectedSkuList, count: number, curGoodDetail: GoodDetailData) => {
    const newGroupSkuList: string[] = [];
    if (sku.groupList && sku.groupList.length > 0) {
      sku.groupList.forEach((groupList) => {
        if (groupList.groupSkuList) {
          groupList.groupSkuList.forEach((groupSkuListItem) => {
            if (groupSkuListItem.count > 0) {
              newGroupSkuList.push(`${groupSkuListItem.groupSkuId},${groupSkuListItem.count}`);
            }
          });
        }
      });
    }

    const spu_specifications = newGroupSkuList.join(';');
    const cid = getCID(source);
    const bid = getBID(source, 'MULT_SKU_ADD_TO_SHOPCART_BTN', 'MC');
    const user_get_mode = getTrackUserGetMode();

    const skuLab = {
      discount_information: sku.extraInfo?.logData ? (JSON.parse(sku.extraInfo.logData)?.discount_information) : '',
      discount_amount: ((totalPrice.originPrice.amount - totalPrice.discountPrice?.amount) / 100).toFixed(2),
      bid,
      original_price: totalPrice.originPrice,
      sale_price: totalPrice.discountPrice,
      shop_id,
      sku_id: sku.skuId,
      sku_number: count,
      spu_id: curGoodDetail?.spuId,
      currency_type: totalPrice.currency,
      discount_price: totalPrice?.discountPrice || '',
      activity_type: sku?.activityInfoList?.[0].activityType || 0,
      spu_specifications,
      user_get_mode,
    };
    const tagLab = {
      [cid]: {
        ...skuLab,
        bid,
      },
    };
    Statistics.setTag && Statistics.setTag(key, tagLab);
    Statistics.click(cid, bid, skuLab);
  }

  //规格页面数量埋点
  static countMC = (count: number, lab: any, button_name: number) => {
    const cid = getCID(lab.source_page);
    const user_get_mode = getTrackUserGetMode();
    const countLab = {
      ...lab,
      sku_number: count,
      button_name,
      user_get_mode,
    };
    Statistics.click(cid, BID.MULT_SKU_CHANGE_COUNT.MC, countLab);
  }

  // 备注曝光
  static remarkMV = (source: number, shop_id: string, spu_id: number, multiSkuModel, curGoodDetail, shopId, canUserCoupon) => {
    const cid = getCID(source);
    const bid = getBID(source, 'MULT_SKU_REMARK', 'MV');
    const normalLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);
    const user_get_mode = getTrackUserGetMode();
    Statistics.view(cid, bid, {
      user_get_mode,
      ...normalLab
    });
  }

  // 备注点击
  static remarkMC = (source: number, shop_id: string, spu_id: number, multiSkuModel, curGoodDetail, shopId, canUserCoupon) => {
    const cid = getCID(source);
    const bid = getBID(source, 'MULT_SKU_REMARK', 'MC');
    const normalLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);
    const user_get_mode = getTrackUserGetMode();
    Statistics.click(cid, bid, {
      user_get_mode,
      ...normalLab
    });
  }

  //规格模块曝光
  static attrGroupMV = (source: number, shop_id: string, spu_id: number, spu_specifications_number: number, group_name: string, rule_tag: string, discount_price: string, activity_type: number, multiSkuModel, curGoodDetail, canUserCoupon) => {
    const cid = getCID(source);
    const bid = getBID(source, 'MULT_SKU_SKULIST', 'MV');
    const normalLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shop_id, canUserCoupon, source);
    const user_get_mode = getTrackUserGetMode();

    const lab = {
      spu_specifications_number,
      group_name,
      rule_tag,
      discount_price,
      activity_type,
      user_get_mode,
      ...normalLab
    };
    Statistics.view(cid, bid, lab);
  }

  // 919活动多规格弹窗MV
  static nineOneNineMultiSkuPageMV = (shop_id: number, user_status: number, shop_brand_id: number) => {
    const cid = CID.nine_one_nine;
    const bid = BID.NINE_ONE_NINE_MULT_SKU_BID.MV;
    const lab = {
      shop_id,
      user_status,
      shop_brand_id,
    };
    Statistics.view(cid, bid, lab);
  }

  // 919活动弹窗MV(无需修改）
  static gaodaMarketingFloatingLayerMV(lab = {}, parameterCid?: string) {
    const cid = parameterCid || CID.nine_one_nine;
    const bid = BID.MARKETFLOADINGLAYER_BID.MV;
    Statistics.view(cid, bid, lab);
  }

  // 919活动弹窗MC(无需修改）
  static gaodaMarketingFloatingLayerMC(lab = {}, parameterCid?: string) {
    const cid = parameterCid || CID.nine_one_nine;
    const bid = BID.MARKETFLOADINGLAYER_BID.MC;
    Statistics.click(cid, bid, lab);
  }

  // 919活动弹窗MV(无需修改）
  static gaodaMarketingPopUPMV(lab = {}, parameterCid?: string) {
    const cid = parameterCid || CID.nine_one_nine;
    const bid = BID.MARKETFLOADINGLAYER_POPUP_VIEW_BID.MV;
    Statistics.view(cid, bid, lab);
  }

  // 919活动弹窗MC(无需修改）
  static gaodaMarketingPopUPMC(lab = {}, parameterCid?: string) {
    const cid = parameterCid || CID.nine_one_nine;
    const bid = BID.MARKETFLOADINGLAYER_POPUP_VIEW_BID.MC;
    Statistics.click(cid, bid, lab);
  }

  // 919活动弹窗MV(无需修改）
  static nineOneNineMultiSkuPopupViewMV = (shop_id: number, user_status: number, shop_brand_id: number, remind_reason: number) => {
    const cid = CID.nine_one_nine;
    const bid = BID.NINE_ONE_NINE_POPUP_VIEW_BID.MV;
    const lab = {
      shop_id,
      user_status,
      shop_brand_id,
      remind_reason,
    };
    Statistics.view(cid, bid, lab);
  }

  // 919活动弹窗按钮MC(无需修改）
  static nineOneNineMultiSkuPopupViewMC = (button_name: string, shop_id: number, user_status: number, shop_brand_id: number, remind_reason: number) => {
    const cid = CID.nine_one_nine;
    const bid = BID.NINE_ONE_NINE_POPUP_VIEW_BID.MC;
    const lab = {
      button_name,
      shop_id,
      user_status,
      shop_brand_id,
      remind_reason,
    };
    Statistics.click(cid, bid, lab);
  }

  // 919活动落地页-规格浮层-加购(无需修改）
  static nineOneNineAddShopcartMC = (sku_id: number, user_status: number, shop_brand_id: number) => {
    const cid = CID.nine_one_nine;
    const bid = BID.NINE_ONE_NINE_MULT_SKU_ADD_TO_SHOPCART_BTN.MC;
    const lab = {
      sku_id,
      user_status,
      shop_brand_id,
    };
    Statistics.click(cid, bid, lab);
  }

  // 店铺休息弹窗Mv（待定）
  static previewCommonDialogMV = (source: number, shop_id: number, user_status: number, shop_brand_id: number, remind_reason: number) => {
    const fixedPrice = source === SOURCE_MULTI_SKU_NUM.FIXED_PRICE;
    const cid = getCID(source);
    const bid = getBID(source, 'PREVIEW_COMMON_DIALOG_BID', 'MV');
    const lab = {
      shop_id,
      remind_reason,
    };
    if (!fixedPrice) {
      Object.assign(lab, { user_status, shop_brand_id });
    }
    Statistics.view(cid, bid, lab);
  }

  // 商品已下架、删除mv（待定）
  static previewCommonDialogMC = (source: number, shop_id: number, user_status: number, shop_brand_id: number, remind_reason: number) => {
    const fixedPrice = source === SOURCE_MULTI_SKU_NUM.FIXED_PRICE;
    const cid = getCID(source);
    const bid = getBID(source, 'PREVIEW_COMMON_DIALOG_BID', 'MC');
    const lab = {
      shop_id,
      remind_reason,
    };
    if (!fixedPrice) {
      Object.assign(lab, { user_status, shop_brand_id });
    }
    Statistics.click(cid, bid, lab);
  }

  static stepperMC = (lab) => {
    const cid = getCID(lab.source_page);
    const bid = BID.NORMAL_MULTI_SKU_MODAL_STEPPER_BID.MC;
    const user_get_mode = getTrackUserGetMode();

    Statistics.click(cid, bid, { ...lab, user_get_mode });
  }

  static multiSameSpuChangeClickMC = (source, lab) => {
    const cid = getCID(source);
    const bid = BID.MULTI_SAME_SPU_LANDSCAPE_VIEW_BID.MC;
    Statistics.click(cid, bid, lab);
  }

  static multiSameSpuChangeMV = (source, lab) => {
    const cid = getCID(source);
    const bid = BID.MULTI_SAME_SPU_LANDSCAPE_VIEW_BID.MC;
    Statistics.view(cid, bid, lab);
  }

  // 一口价-规格浮层-门店入口-MC
  static fixedPriceShopEntryMC = (source, shop_id: number) => {
    const cid = getCID(source);
    const bid = getBID(source, 'FIXED_PRICE_SHOP_ENTRY', 'MC');
    Statistics.click(cid, bid, { shop_id });
  }
  // 一口价-规格浮层-门店入口-MV
  static fixedPriceShopEntryMV = (source, shop_id: number) => {
    const cid = getCID(source);
    const bid = getBID(source, 'FIXED_PRICE_SHOP_ENTRY', 'MV');
    Statistics.view(cid, bid, { shop_id });
  }

  // 营养成分/过敏源 点击
  static nutritionAllergenMC = (params: NutritionAllergenType) => {
    const {
      source, shop_id, sku_id, spu_id, spu_property_type
    } = params;
    const cid = getCID(source);
    const bid = BID.NUTRITION_ALLERGEN_BID.MC;

    Statistics.click(cid, bid, {
      shop_id, sku_id, spu_id, spu_property_type
    });
  }

  // 营养成分/过敏源 曝光
  static nutritionAllergenMV = (params: NutritionAllergenType) => {
    const {
      source, shop_id, sku_id, spu_id, spu_property_type
    } = params;
    const cid = getCID(source);
    const bid = BID.NUTRITION_ALLERGEN_BID.MV;

    Statistics.view(cid, bid, {
      shop_id, sku_id, spu_id, spu_property_type
    });
  }
}
